// AKBS へ登録したあとの、メインタスクの片付け
//
// サブタスク「契約詳細承認」「雇用指示承認」は、AKBS へ登録したときにバックが自動で完了にする（RP_api の manager/akbsSubTask.js）
// サブタスク画面で手で完了にしたときは「サブタスクが全部完了したらメインタスクも完了にする」が動くが、自動で完了にしたときは動かないので、ここで同じことをする
// 対象は、その承認のサブタスクが「最終完了タスク」になっているときだけ（ユーザー決定 2026-09-21）
//   ・ほかのサブタスクが全部完了している → メインタスクを完了にする（受注処理なら、見積りの受注の状態も「受注完了」にする。サブタスク画面の updateMain と同じ）
//   ・未完了（status が open）のサブタスクが残っている → メインタスクは完了にできないので、「最終完了タスク」を残っているサブタスクへ付け替える
//     （付け替え先は、残っている中で並びが一番最後のもの。そのサブタスクを完了にしたときに、メインタスクが完了になる）
import * as utils from '@libs/utils'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as requestPostManager from '@managers/requestPostManager'
import * as estimateManager from '@managers/estimateManager'
import * as logManager from '@managers/logManager'

/**
 * AKBS へ登録したあとに呼ぶ
 * @param {*} context 画面（this）
 * @param {Object} main メインタスク（_id・type・requestNo・estimateNo）
 * @param {String} approveName 承認のサブタスクの名前（AKBS_SUB_TASK.CONTRACT_APPROVE か EMPLOYMENT_APPROVE。含むかで見る）
 * @returns {Promise<{ mainDone: Boolean, movedTo: String }>} mainDone：メインタスクを完了にした。movedTo：最終完了タスクを付け替えた先のサブタスク名（付け替えていなければ空）
 */
export async function finishAfterAkbs(context, main, approveName) {
  const result = { mainDone: false, movedTo: '' }
  try {
    if (!main || !main._id) {
      return result
    }
    const isOrder = main.type == 'order'
    // 受注処理のサブタスクは別の種類で持っている（並びは displayOrder 順で返る。削除済みは含まない）
    const subTasks = (isOrder
      ? await taskRequestManager.getByOrderId(context, main._id)
      : await taskRequestManager.getByRequestPostId(context, main._id)) || []
    const save = task => (isOrder ? taskRequestManager.orderTaskRequestUpdate(context, task) : taskRequestManager.update(context, task))

    // 承認のサブタスクが最終完了タスクのときだけ
    const approve = subTasks.find(s => String(s.requestTask || '').includes(approveName))
    if (!approve || approve.finalCompletionTask != '1' || approve.status != 'done') {
      return result
    }

    // 未完了が残っている：最終完了タスクを、残っている中で一番最後のサブタスクへ付け替える
    const open = subTasks.filter(s => s !== approve && s.status == 'open')
    if (open.length) {
      const next = open[open.length - 1]
      approve.finalCompletionTask = ''
      next.finalCompletionTask = '1'
      await save(approve)
      await save(next)
      result.movedTo = next.requestTask || ''
      return result
    }

    // 全部完了：メインタスクを完了にする
    const done = await requestPostManager.markAsDone(context, main._id)
    if (!done) {
      return result
    }
    result.mainDone = true
    logManager.recording(context, logManager.Loglevel.INFO, 'メインタスク', 'ステータス完了', 'メインタスク（お問い合わせ番号：' + (main.requestNo || '') + '）のステータスを完了しました。')
    if (isOrder && main.estimateNo) {
      const name = utils.deleteKana(context.$store.getters.user.user_name)
      await estimateManager.changeOrderStatus(context, main.estimateNo, '受注完了', name)
    }
  } catch (e) {
    // 登録そのものは済んでいるので、ここで失敗しても止めない（サブタスク画面で保存すれば同じ処理が動く）
    console.log(e)
  }
  return result
}
